<template>
  <div class="box box-remark">
    <span class="title">Remarks</span>
    <div class="remarks-container">
      <div
        v-for="(item, index) in remarkDetail"
        :key="index"
        class="remark-box">
        <div class="remark-header">
          <span>{{ item.cs_name }}</span>
          <span>{{ item.created_at }}</span>
        </div>
        <p>{{ item.message }}</p>
      </div>
    </div>
    <div class="remark-add">
      <v-input
        v-model="message"
        class="mg-b-15"
        append="Add"
        @keyEnter="handlerAddRemark"
        @handlerAppend="handlerAddRemark"/>
    </div>
  </div>
</template>

<script>
import {addTicketRemark, getTicketRemark} from '@api/ticket'
import {addPolicyRemark} from '@api/policy'
import {quoteRemarkAdd} from '@api/quote'

export default {
  name: 'right-remark',
  props:{
    ticketId:{
      type:[String,Number],
      default:0
    },
    pcyId:{
      type:[String,Number],
      default:0
    },
    quoId:{
      type:[String,Number],
      default:0
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    isPolicy: {
      type: Boolean,
      default: false
    },
    remark: {
      type: Array,
      default: () => ([])
    },
  },
  data(){
    return{
      message:'',
      remarkDetail:[]
    }
  },
  watch:{
    remark:{
      immediate:true,
      handler(val){
        if(val){
          this.remarkDetail = val||[]
        }
      }
    }
  },
  methods:{
    handlerAddRemark() {
      if (this.message) {
        if(this.isPolicy){
          this.network().addPolicyRemark()
          return
        }
        if(this.isQuote){
          this.network().quoteRemarkAdd()

        }
      }
    },
    network(){
      return{
        getRemarkDetail: async (params) => {
          if(this.ticketId)
          {
            const { data } = await getTicketRemark({
              ticket_id: this.ticketId,
            })
            this.remarkDetail = data
          }
        },
        addPolicyRemark: async () => {
          const { data } = await addPolicyRemark({
            pcy_id: this.pcyId,
            message: this.message
          })
          this.message = ''
          this.remarkDetail.unshift(data)
        },
        addTicketRemark: async params => {
          const { data } = await addTicketRemark(params)
          this.message = ''
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.network().getRemarkDetail({hideLoading:true})
        },
        quoteRemarkAdd: async (params = {}) => {
          const { data } = await quoteRemarkAdd({
            quo_id: this.quoId,
            message: this.message ,
          })
          this.message = ''
          this.$message({
            type: 'success',
            message:'Success'
          })
          this.remarkDetail.unshift(data)
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  padding: 29.5px 0;
  border-bottom: 0px!important;
  .remark-add {
    z-index: 2;
    margin: 0 -15px;
    padding: 15px 15px 0 15px;
    //border-top: 1px solid #dddfe7;
  }
  .title {
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 5px;
    font-size: 14px;
    font-weight: bold;
  }
  .remarks-container {
    z-index: 1;
    max-height: 300px;
    overflow-y: auto;

    .remark-box {
      margin-bottom: 10px;
      font-size: 12px;
      color: #91939a;

      .remark-header {
        display: flex;
        justify-content: space-between;

        span:first-child {
          font-weight: bold;
        }
      }

      p {
        padding-bottom: 10px;
        color: #616266;
      }
    }
  }
}
</style>
